import formatMoney from '../formatMoney';

const updatePrice = ({
  priceEl,
  compareAtPriceEl,
  badgeEl,
  price,
  compareAtPrice,
  badgeTemplate,
  moneyFormat
}) => {
  if (!priceEl) return;
  const fmt = moneyFormat || '£{{amount}}';

  if (badgeEl) {
    if (compareAtPrice > price) {
      const saleDifference = compareAtPrice - price;
      badgeEl.textContent = badgeTemplate.replace('{{ amount }}', formatMoney(saleDifference, fmt));
      badgeEl.classList.remove('hidden');
    } else {
      badgeEl.textContent = '';
      badgeEl.classList.add('hidden');
    }
  }

  if (compareAtPriceEl) {
    if (compareAtPrice > price) {
      compareAtPriceEl.textContent = formatMoney(compareAtPrice, fmt);
      compareAtPriceEl.classList.remove('hidden');
    } else {
      compareAtPriceEl.textContent = '';
      compareAtPriceEl.classList.add('hidden');
    }
  }
  priceEl.textContent = formatMoney(price, fmt);
};

export default updatePrice;
